import createSvgIcon from "@mui/material/utils/createSvgIcon";

export const MtCookingClass = createSvgIcon(
  <svg viewBox="0 0 346.75 344.1" stroke="currentColor" fill="currentColor">
    <path d="M238.94,174.92c.13,0,2.32-1.92,2.47.48.01.24-.98,1.7-.99,2.98-.31,24.04-12.47,44.5-26.19,63.31l-90.8-.27c-14.9-18.79-26.69-41.98-26.99-66.51,47.46-.7,95.04.94,142.5,0h0Z" />
    <path d="M247.14,167.62c-1.49,1.2-3.35,1.27-5.17,1.34l-148.98-.1c-8.22.38-6.49-21.86-3.53-24.4,1.25-1.08,2.82-1.47,4.45-1.55l149.96.08c8.35-.22,6.47,22.06,3.27,24.64h0Z" />
    <path d="M173.94,137.92l-1.5-2.49,42.54-46.55c-2.61-21.99,15.51-13.23,26.37-5.37,5.43,3.94,8.59,5.83,6.62,13.44s-7.08,4.63-9.43,7.56c-5.33,6.64-9.6,22.24-14.9,30.1-.81,1.2-1.49,2.43-2.69,3.31h-47.01Z" />
    <path d="M122.58,247.06l91.2.02c2.28.78,9.43,20.62,4.67,23.35l-97.48.46c-8.22-1.54.53-18.71,1.61-23.83Z" />
  </svg>,
  "cookingclass"
);
